// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"3411dc19","320":"d0bfc55d","668":"4741658c","715":"7606403e"}[chunkId] + ".chunk.js";
};